import React from 'react';
import {
  MONTH_NAMES,
  DAY_NAMES_FULL,
  EVENT_TYPES,
  calculateEndTime,
  eventsByDayForMonth,
  getDaysInMonth,
  getEventsForDay,
  isToday,
  toDateKey,
} from '../../utils/calendarHelpers';

function CalendarMonthView({
  currentDate,
  eventsByDate,
  selectedDate,
  onSelectDate,
  onNavigateMonth,
}) {
  const calendarEvents = eventsByDayForMonth(eventsByDate, currentDate);
  const dayCells = getDaysInMonth(currentDate);

  return (
    <div className="calendar-month-view">
      <div className="calendar-month-nav">
        <button type="button" className="calendar-nav-btn" onClick={() => onNavigateMonth(-1)}>
          ‹ Előző hónap
        </button>
        <h3 className="calendar-month-title">
          {MONTH_NAMES[currentDate.getMonth()]} {currentDate.getFullYear()}
        </h3>
        <button type="button" className="calendar-nav-btn" onClick={() => onNavigateMonth(1)}>
          Következő hónap ›
        </button>
      </div>

      <div className="calendar-grid">
        <div className="calendar-header-row">
          {DAY_NAMES_FULL.map((day) => (
            <div key={day} className="day-header">
              {day}
            </div>
          ))}
        </div>

        <div className="calendar-days">
          {dayCells.map((day, index) => (
            <div
              key={index}
              className={`calendar-day ${day ? 'has-date' : 'empty'} ${
                day &&
                (calendarEvents[day] || []).filter((e) => e.status !== 'cancelled').length > 0
                  ? 'has-events'
                  : ''
              } ${day && isToday(day, currentDate) ? 'today' : ''} ${
                selectedDate === day ? 'selected' : ''
              }`}
              onClick={() => day && onSelectDate(selectedDate === day ? null : day)}
              onKeyDown={(e) => {
                if (day && (e.key === 'Enter' || e.key === ' ')) {
                  e.preventDefault();
                  onSelectDate(selectedDate === day ? null : day);
                }
              }}
              role={day ? 'button' : undefined}
              tabIndex={day ? 0 : undefined}
            >
              {day ? (
                <>
                  <span className="day-number">{day}</span>
                  {calendarEvents[day] ? (
                    <div className="event-indicator">
                      <span className="event-count">{calendarEvents[day].length}</span>
                    </div>
                  ) : null}
                </>
              ) : null}
            </div>
          ))}
        </div>
      </div>

      {selectedDate &&
      getEventsForDay(
        eventsByDate,
        toDateKey(new Date(currentDate.getFullYear(), currentDate.getMonth(), selectedDate))
      ).length > 0 ? (
        <div className="event-details">
          <h4>
            Programok — {MONTH_NAMES[currentDate.getMonth()]} {selectedDate}.
          </h4>
          <div className="events-list">
            {getEventsForDay(
              eventsByDate,
              toDateKey(new Date(currentDate.getFullYear(), currentDate.getMonth(), selectedDate))
            ).map((event, index) => {
              const eventType = EVENT_TYPES[event.type] || EVENT_TYPES.cultural;
              const endTime = calculateEndTime(event.time, event.duration || 60);
              return (
                <div key={event.id || index} className="event-item">
                  <div className="event-header">
                    <div
                      className="event-type-badge"
                      style={{ backgroundColor: eventType.color }}
                    >
                      <span className="event-icon">{eventType.icon}</span>
                      <span className="event-type">{eventType.name}</span>
                    </div>
                    <div className="event-time-range">
                      {event.time} – {endTime}
                    </div>
                  </div>
                  <h5 className="event-title">{event.title}</h5>
                  {event.description && event.description.trim() ? (
                    <p className="event-description">{event.description}</p>
                  ) : null}
                  <div className="event-meta">
                    <span className="event-duration">⏱️ {event.duration || 60} perc</span>
                  </div>
                </div>
              );
            })}
          </div>
        </div>
      ) : null}
    </div>
  );
}

export default CalendarMonthView;
